import * as React from "react";
const IconDownArrowBox = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M56 3H8C5.2 3 3 5.2 3 8v48c0 2.8 2.2 5 5 5h48c2.8 0 5-2.2 5-5V8c0-2.8-2.2-5-5-5m3 53c0 1.7-1.3 3-3 3H8c-1.7 0-3-1.3-3-3V8c0-1.7 1.3-3 3-3h48c1.7 0 3 1.3 3 3z" />
    <path d="m42.7 32.5-9.4 9.4V19.4c0-.6-.4-1-1-1s-1 .4-1 1v22.5l-9-9c-.4-.4-1-.4-1.4 0s-.4 1 0 1.4L31.6 45c.2.2.5.3.7.3s.5-.1.7-.3l11.1-11.1c.4-.4.4-1 0-1.4s-1-.4-1.4 0" />
  </svg>
);
export default IconDownArrowBox;
